"use strict";
/**
 *  timeCueModule Module
 *
    Description 策划中心 指挥监测中心 全国热点内容管理
 *  Author: fanglijuan 2017-7-17
 */
angular.module('planCommandMonitorCountryHotspotContentMgrModule', [])
    .controller('planCommandMonitorCountryHotspotContentMgrController', ["$scope", "$filter", "trsHttpService", "initComDataService", 'planCommandMonitorService', '$q', 'modalDialog',
        function ($scope, $filter, trsHttpService, initComDataService, planCommandMonitorService, $q, modalDialog) {
            initStatus();
            initData();
            /** [initStatus description：初始化状态]*/
            function initStatus() {
                $scope.status = {
                    copyCurrPage: '',
                    item1: ['97', '98', '99'],
                    item2: ['2', '1', '1'],
                    item3: ['1', '1', '1'],
                    item4: ['19:30', '07:30', '14:30'],
                    item5: ['07:30', '14:30', '19:30'],
                    page: {
                        CURRPAGE: 1,
                        PAGESIZE: 20
                    },
                };
                $scope.data = {
                    dataManagement: []
                };
                $scope.cusinfos = {
                    hours: {},
                    meetings: {
                        values: {}
                    }
                };
                addCusinfos().then(function () {
                    dataManagement().then(function () {
                        setCurrentValue();
                        $scope.searchHot();
                    });
                });

                function setCurrentValue() {
                    for (var i = $scope.cusinfos.hours.values.length - 1; i >= 0; i--) {
                        if ($scope.cusinfos.hours.values[i].disabled === false) {
                            $scope.cusinfos.hours.curValue.value = $scope.cusinfos.hours.values[i].value;
                            $scope.cusinfos.hours.curValue.name = $scope.cusinfos.hours.values[i].value;
                            $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                            break;
                        }
                    }
                }
                var defaultDate = new Date(); //获取当前
                defaultDate = Date.parse(defaultDate);
                defaultDate = timeStamp(defaultDate);
                $scope.cheDate = defaultDate; //当前时间的标准格式
                $scope.isOnThatDay = true; //用于判断是否是当天的额条件
                $scope.nowHour = $filter("date")(Date.parse(new Date()), "HH");
                // $scope.cusinfos.hours.curValue.value = $filter("date")(Date.parse(new Date()), "HH");
                // $scope.cusinfos.hours.curValue.name = $filter("date")(Date.parse(new Date()), "HH");
                judgeDate();
                // $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                $scope.params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'customHotPointMgr',
                    "method": 'getHotPointList',
                    "page_size": $scope.status.page.PAGESIZE,
                    "page_no": $scope.status.page.CURRPAGE - 1,
                    "hot_type": '001',
                    "area_id": '001',
                    "search_hour": $scope.ischecked
                };
                $scope.copyParams = angular.copy($scope.params);
            }
            /** [fieldMor description：相关文章弹框] */
            $scope.RelateArticle=function(transmitSearch,info,hot_type){
                planCommandMonitorService.regionRelevantArticles(transmitSearch,info,hot_type)
            };
            /**
             * [addCusinfos description：用于循环遍历出hour中的24小时的数据]
             */
            function addCusinfos() {
                var defer = $q.defer()
                $scope.cusinfos.hours.values = [];
                $scope.cusinfos.hours.curValue = { value: '', name: '' };
                for (var i = 1; i < 25; i++) {
                    var strV = '',
                        strS = '';
                    if (i < 10) {
                        strV += "0" + i;
                        strS += "0" + i; //用于确保数据的HH格式
                    } else if (i === 24) {
                        strV += "00";
                        strS += i; //24时的value值为00
                    } else {
                        strV += i;
                        strS += i; //其余值则宝石时间与值以及变现形式一致
                    }
                    $scope.cusinfos.hours.values[i - 1] = { value: '', show: '', disabled: '' };
                    $scope.cusinfos.hours.values[i - 1].value = strV;
                    $scope.cusinfos.hours.values[i - 1].show = strS;
                }
                $scope.cusinfos.hours.curValue.value = '';
                $scope.cusinfos.hours.curValue.name = '';
                defer.resolve();
                return defer.promise;
            }
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                requestMeetData().then(function () {
                    initDropDown();
                    requestData();
                    judgeMeet();
                    fieldMor("1");
                    fieldMor("2");
                    fieldMor("3");
                });
            }
            /**
             * [requestMeetData description:获取的3会的页面实现内容]
             */
            function requestMeetData() {
                var deffer = $q.defer();
                var meetParams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'customHotPointMgr',
                    "method": 'getCustomHotPoint',
                    "page_size": 10,
                    "page_no": 0
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), meetParams, 'get').then(function (data) {
                    $scope.cusinfos.meetings.values = data.mapResult.content[0];
                    $scope.meetInfo = $scope.cusinfos.meetings.values;
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /** [fieldMor description：拼接三会信息字符串] */
            function fieldMor(type) {
                $scope['meetMorTxt' + type] = '';
                var fieldMor1 = $scope.meetInfo['pointdayFr' + type] == 1 ? "当日" : "昨日";
                var fieldMor2 = $scope.meetInfo['pointdayTo' + type] == 1 ? "当日" : "昨日";
                $scope['meetMorTxt' + type] += "*" + fieldMor1 + $scope.meetInfo['pointFr' + type] + '-' + fieldMor2 + $scope.meetInfo['pointTo' + type];
            }
            /**
             * [judgeDate description:判断可以是否需要禁用]
             */
            function judgeDate() {
                // var cusList2 = [];
                // cusList2.push($scope.cusinfos.years.curValue.value);
                // cusList2.push($scope.cusinfos.months.curValue.value);
                // cusList2.push($scope.cusinfos.days.curValue.value);
                //var judgeInfo = cusList2.join("/");
                var judgeInfo = $scope.cheDate;
                judgeInfo = Date.parse(judgeInfo);
                var judgeInfo1 = judgeInfo + 86400000
                var nowTime = new Date();
                nowTime = Date.parse(nowTime);
                $scope.timeJudge = nowTime < judgeInfo;
                $scope.timeJudge1 = nowTime < judgeInfo1;
            }
            /**
             * [judgeMeet description：判断是否禁用三会按钮]
             */
            function judgeMeet() {
                var judgeCondi = (!($scope.timeJudge)) && ($scope.timeJudge1);
                if (judgeCondi) {
                    $scope.meetPointJudge1 = false; //默认当天早会是不会被禁用的
                    $scope.meetPointJudge2 = '';
                    var meetCondition2 = "07:30";
                    var strA2 = meetCondition2.slice(0, 2);
                    var strB2 = meetCondition2.slice(3, 5);
                    var nowMeetHour2 = new Date().getHours();
                    var nowMeetMin2 = new Date().getMinutes();
                    $scope.meetPointJudge2 = !((nowMeetHour2 > strA2) || ((nowMeetHour2 == strA2) && (nowMeetMin2 > strB2)));
                    $scope.meetPointJudge3 = '';
                    var meetCondition3 = "14:30";
                    var strA3 = meetCondition3.slice(0, 2); //22
                    var strB3 = meetCondition3.slice(3, 5);
                    var nowMeetHour3 = new Date().getHours(); //20
                    var nowMeetMin3 = new Date().getMinutes();
                    $scope.meetPointJudge3 = !((nowMeetHour3 > strA3) || ((nowMeetHour3 == strA3) && (nowMeetMin3 > strB3)));
                } else {
                    $scope.meetPointJudge1 = false;
                    $scope.meetPointJudge2 = false;
                    $scope.meetPointJudge3 = false;
                };
            }
            /**
             * [description:当日期选择监听它的变化]
             */
            $scope.$watch('cheDate', function () {
                judgeDate();
                judgeMeet();
                var nowTime2 = new Date();
                nowTime2 = Date.parse(nowTime2);
                nowTime2 = timeStamp(nowTime2);
                var compareTime = Date.parse($scope.cheDate);
                compareTime = timeStamp(compareTime);
                $scope.isOnThatDay = (nowTime2 === compareTime);
                if (!$scope.isOnThatDay) {
                    $scope.cusinfos.hours.curValue.value = '24';
                    $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                } else {
                    for (var i = $scope.cusinfos.hours.values.length - 1; i >= 0; i--) {
                        if ($scope.cusinfos.hours.values[i].disabled === false) {
                            $scope.cusinfos.hours.curValue.value = $scope.cusinfos.hours.values[i].show;
                            break;
                        }
                    }
                    // $scope.cusinfos.hours.curValue.value = new Date().getHours();
                    $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                }
                $scope.searchHot();
            });
            /**
             * [timeStamp:将日期字符串转化为标准格式]
             */
            function timeStamp(group) {
                return $filter("date")(group, "yyyy-MM-dd").toString();
            };
            /**
             * [requestData description] 请求数据
             */
            function requestData() {
                // var cusList = [];
                // cusList.push($scope.cusinfos.years.curValue.value);
                // cusList.push($scope.cusinfos.months.curValue.value);
                // cusList.push($scope.cusinfos.days.curValue.value);
                // var dateInfo = cusList.join("-");
                var areaTimeT = "";
                var date = $scope.cheDate;
                date = Date.parse(date);
                date = timeStamp(date);
                var dateArr = date.split("-");
                if ($scope.cusinfos.hours.curValue.value >= 0 && $scope.cusinfos.hours.curValue.value <= 23) {
                    areaTimeT = $scope.cusinfos.hours.curValue.value + "时";
                }
                $scope.params.search_hour = $scope.ischecked;
                $scope.dateShow = dateArr[0] + "年" + dateArr[1] + "月" + dateArr[2] + "日" + areaTimeT + "全国热点热度表";
                $scope.params.search_date = date;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "post").then(function (data) {
                    $scope.cusinfos.infos = data.mapResult.content.record;
                    $scope.status.page.ITEMCOUNT = data.mapResult.content.record_count;
                    $scope.status.page.PAGECOUNT = data.mapResult.content.pagecount;
                    $scope.transmitSearch = $scope.params.search_hour;
                });
            }
            /**
             * [switchBtn description:切换在大屏上显示状态]
             */
            $scope.switchBtn = function (group) {
                if (group.displayFlag === 1) {
                    group.displayFlag = 0;
                } else {
                    group.displayFlag = 1;
                }
                updateDisplay(group);
            };
            /**
             * [initDropDown description] 初始化下拉框
             */
            function initDropDown() {
                //时间
                $scope.status.timeArray = initComDataService.logMgrTime();
                $scope.status.timeSelected = $scope.status.timeArray[1];
            }
            /**
             * [selectPageNum description] 选择每页显示的数据数量
             * @return {[type]} [description]
             */

            $scope.selectPageNum = function () {
                $scope.status.CurrPageCopy = 1;
                $scope.params.page_no = $scope.status.page.CURRPAGE - 1;
                $scope.params.page_size = $scope.status.page.PAGESIZE;
                requestData();
            };
            /**
             * [pageChanged description]分页
             */
            $scope.pageChanged = function () {
                $scope.status.copyCurrPage = $scope.status.page.CURRPAGE;
                $scope.params.page_no = $scope.status.page.CURRPAGE - 1;
                requestData();
            };
            /*跳转指定页面*/
            $scope.jumpToPage = function () {
                if (!$scope.status.copyCurrPage) return;
                if ($scope.status.copyCurrPage > $scope.status.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.status.page.PAGECOUNT;
                }
                $scope.status.page.CURRPAGE = $scope.status.copyCurrPage;
                $scope.params.page_no = $scope.status.copyCurrPage - 1;
                requestData();
            };
            /**
             * [changeFlagId description：更改标志ID]
             * @return {[type]} [description]
             */
            $scope.changeFlagId = function (info) {
                planCommandMonitorService.editSignedArticle('', '', '', '', info.signGuid,
                    function (guidValue) {
                        var flagParams = {
                            "serviceid": 'mlf_bigdatascreen',
                            "methodname": 'queryDataFromBigScreen',
                            "modalname": 'areaHotPointFunCommon',
                            "method": 'updateSignGuid',
                            "guid_updt": guidValue,
                            "areahot_id": info.areahot_id,
                            "search_hour": $scope.cusinfos.hours.curValue.value,
                            "guid_old": info.signGuid,
                            "hot_type": '0',
                            "display_flag": info.displayFlag
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), flagParams, 'post').then(function () {
                            requestData();
                        });
                    });
            };
            /**
             * [exportExcel description: 导出excel]
             */
            $scope.exportExcel = function (group) {
                var title = group.sighTitle.replace(/%/g, "%25");
                var url = "/wcm/bigdata.do?areahot_id=" + group.areahot_id + "&filename=" + title + "&method=hotpointExport&search_hour=" + $scope.cusinfos.hours.curValue.value + "&modalname=&hot_type='001'";
                window.open(url);
            };
            /**
             * [searchHot description：通过查询查询热点并再次请求该条件的数据]
             */
            $scope.searchHot = function () {
                var hotJudge = (!$scope.timeJudge) && (($scope.cusinfos.hours.curValue.value <= $scope.nowHour) || (!$scope.timeJudge1) || ($scope.cusinfos.hours.curValue.value >= 97));
                if (hotJudge) {
                    requestData();
                } else {
                    modalDialog.alertType('提示信息', '请调整查询时间!', 'info', 'confirm', function () {});
                }
            };
            /**
             * [getHours description:获取到需要查询的时间段]
             */
            $scope.getHours = function (group) {
                $scope.params = $scope.copyParams;
                $scope.cusinfos.hours.curValue.value = group.value;
                $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                $scope.params.search_hour = $scope.cusinfos.hours.curValue.value;
                $scope.searchHot();
            };
            /**
             * [dayHotSearch description：当日热点的选中小骨]
             */
            $scope.dayHotSearch = function () {
                $scope.cusinfos.hours.curValue.value = "24";
                $scope.params.search_hour = $scope.cusinfos.hours.curValue.value;
                $scope.ischecked = $scope.cusinfos.hours.curValue.value;
            };
            /**
             * [getMeeting description:获取会议的选择要求]
             * @return {[type]} [description]
             */
            $scope.getMeeting = function (type) {
                $scope.cusinfos.hours.curValue.value = type == '1' && '97' || type == '2' && '98' || type == '3' && '99';
                $scope.params.day_flag_from = $scope.meetInfo['pointdayFr' + type];
                $scope.params.day_flag_to = $scope.meetInfo['pointdayTo' + type];
                $scope.params.day_time_from = $scope.meetInfo['pointFr' + type];
                $scope.params.day_time_to = $scope.meetInfo['pointTo' + type];
                $scope.params.search_hour = $scope.cusinfos.hours.curValue.value;
                $scope.ischecked = $scope.cusinfos.hours.curValue.value;
            };
            /**
             * [updateDisplay description:更新显示按钮的状态]
             */
            function updateDisplay(group) {
                if (group.displayFlag === 1) {
                    var judge = true;
                } else {
                    var judge = false;
                }
                $scope.disParams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'areaHotPointFunCommon',
                    "method": 'updateDisplayFlag',
                    "search_hour": $scope.cusinfos.hours.curValue.value,
                    "display_flag": judge,
                    "areahot_id": group.areahot_id
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.disParams, 'post')
            }

            function dataManagement() {
                var defer = $q.defer();
                var params = {
                    "typeid": "screen",
                    "serviceid": "customHotPointMgr",
                    "modelid": "getCount"
                }
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function (data) {
                    angular.forEach(data, function (value, key) {
                        $scope.data.dataManagement.push({ 'time': key, 'quantity': value });
                    });
                    for (var i = 0; i < $scope.cusinfos.hours.values.length; i++) {
                        for (var k = 0; k < $scope.data.dataManagement.length; k++) {
                            if ($scope.cusinfos.hours.values[i].show == $scope.data.dataManagement[k].time) {
                                if ($scope.data.dataManagement[k].quantity == 0) {
                                    $scope.cusinfos.hours.values[i].disabled = true;
                                } else {
                                    $scope.cusinfos.hours.values[i].disabled = false;
                                }
                            }
                        }
                    }
                    // console.log($scope.cusinfos.hours.values);
                    // console.log($scope.data.dataManagement);
                    defer.resolve();
                });
                return defer.promise;
            }
        }
    ]);